import { DateTime } from 'luxon';
/**
 * Returns an array of thumbs sorted by their size.
 * Overall size calculated by width*height.
 *
 * @param {Array<{{ width: number, height: number }}>} thumbs List of video thumbnails.
 * @returns {Array<{{ width: number, height: number }}>} Sorted thumb list.
 */
export const getSortedVideoThumbnails = thumbs => {
  return [...thumbs].sort((a, b) => {
    const aSize = a.width * a.height;
    const bSize = b.width * b.height;

    return aSize - bSize;
  });
};

/**
 * Determines if a video is already processed (and available for view) or not.
 *
 * @param {Object} video The video to check for.
 * @returns {Boolean} Whether the video is processed or not.
 */
export const videoIsProcessed = video => {
  return (video?.duration ?? 0) > 0 && video?.embed_url;
};

/**
 * Determines if a video is considered a failed upload or not.
 *
 * @param {Object} video The video to check for.
 * @returns {Boolean} Whether the video is processed or not.
 */
export const videoIsFailedUpload = video => {
  return (
    !videoIsProcessed(video) &&
    DateTime.fromJSDate(new Date(video.created_at)).diff(
      DateTime.now().minus({ hours: 12 }),
      'hours',
    ) < 0
  );
};
export const sortVideoDownloadLinksByResolution = (videoDownloadLinks = []) => {
  return [...videoDownloadLinks].sort((a, b) => {
    const aRes = a.height * b.width;
    const bRes = b.height * b.width;
    if (aRes === bRes) {
      return b.filesize - a.filesize;
    }

    return bRes - aRes;
  });
};
